import { getSelectDropdownListDividerOption } from '../../Select'

export function getActionSelectControlButtonProps(props) {
  return props
}

export function getActionSelectOptions({ actions, t }) {
  return actions.map((action, index) => {
    // Action builders mark a group break with `null`
    if (!action) {
      return getSelectDropdownListDividerOption({ index })
    }

    return {
      ...action,
      ...(action.tooltipContent
        ? {
            tooltipContent: t(
              action.tooltipContent,
              action.tooltipContentValues
            ),
          }
        : null),
      label: t(action.label),
    }
  })
}
